import React, { useEffect } from 'react';

import { useProductModelStore } from '../../store/productModelStore';
import { useDocumentsStateStore } from '../../store/documentsStateStore';
import { findProductByGlobalId } from '../../utils/productModelUtils';
import ISceneDocumentManagerContext from '../../logic/ISceneDocumentManagerContext';

/* Purpose of this component is to give name to a documents which does not have a name yet.
    It is used to set the name of the document based on the project and apartment names. */
const DocumentNamingComponent = (props: ISceneDocumentManagerContext) => {

    const { products, apartments } = useProductModelStore();
    const { getActiveDocument, renameDocument } = useDocumentsStateStore();

    // Rename document by apartment
    useEffect(() => {

        if (!props.apartmentGlobalId || apartments.length === 0)
            return;

        const activeDocument = getActiveDocument();

        if (activeDocument && activeDocument.document.name === "") {

            if (!props.projectGlobalId || !props.apartmentGlobalId)  {
                console.warn("Project or apartment global ID is not set, cannot rename document.");
                return;
            }

            const apartment = apartments.find(apartment => 
                apartment.globalId === props.apartmentGlobalId);
            if ( apartment) {
                const newName = `${apartment.name} (${props.projectGlobalId})`;
                renameDocument(activeDocument, newName);
                console.info(`Renamed document to: ${newName}`);
            } else {
                console.warn("Project or apartment not found in products.");
            }
        }


    }, [apartments]);

    // Rename document by spatial structure
    useEffect(() => {

        if (!props.spatialStructureGlobalId || products.length === 0)
            return;

        const activeDocument = getActiveDocument();

        if (activeDocument && activeDocument.document.name === "") {

            if (!props.projectGlobalId || !props.spatialStructureGlobalId)  {
                console.warn("Project or spatial structure global ID is not set, cannot rename document.");
                return;
            }

            const spatialStructure = findProductByGlobalId(products, props.spatialStructureGlobalId);
            if ( spatialStructure) {
                const newName = `${spatialStructure.name} (${props.projectGlobalId})`;
                renameDocument(activeDocument, newName);
                console.info(`Renamed document to: ${newName}`);
            } else {
                console.warn("Project or spatialStructure not found in products.");
            }
        }


    }, [products]);


    return (
        <>
        </>
    )
    };

export default DocumentNamingComponent;